import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  DonutChart,
  HeadingDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';

import { ICategorie } from '@/modules/wealth/services/suggested-portfolio-builder';

interface Props {
  categories: ICategorie[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Allocation',
  props: {
    categories: null
  },
  setup(__props: any) {

const props = __props as {
  categories: ICategorie[];
}



const formattedCategories = computed(() => {
  return props.categories.map(category => {
    return {
      name: category.type,
      y: category.allocValue.value,
      color: category.color,
      format: category.allocValue.formatted
    };
  });
});

const headingTitle = computed(() => {
  return props.categories.length > 1
    ? `${props.categories.length} classes`
    : '1 classe';
});

const headingSubtitle = computed(() => {
  let products = 0;

  props.categories.forEach(category => {
    products += category.products.length;
  });

  return products > 1 ? `${products} produtos` : '1 produto';
});

function computedStyle(color: string) {
  return { backgroundColor: color };
}

return { __sfc: true,props, formattedCategories, headingTitle, headingSubtitle, computedStyle, DonutChart, HeadingDisplay, ListDisplay }
}

})